import { useTexts } from '@shared/translation';
import type { Column } from '@tanstack/react-table';
import { useDataProvider } from '../DataProviderContext';
import type { Option, TableColumnOptionsMeta, UnknownTextTree } from '../types';

const NO_OPTIONS: Option[] = [];

export const useOptions = (column: Column<any, any> | undefined): Option[] => {
  const { table } = useDataProvider();
  const texts = useTexts<UnknownTextTree>();

  const meta = column?.columnDef.meta as TableColumnOptionsMeta | undefined;

  if (table === undefined || column === undefined || !meta?.options) {
    return NO_OPTIONS;
  }
  return meta.options({ texts, table });
};
